import React from 'react';
import { Status } from 'src/shared/types';
import classNames from 'classnames';
import styles from './StatusChip.module.scss';

export type ChipProps = {
    label: string;
    status: Status;
    className?: string;
};

const StatusChip = (props: ChipProps) => {
    const { label, status, className } = props;

    const chipClassNames = classNames(styles.statusChip, styles[`statusChip${status}`], className);
    return <div className={chipClassNames}>{label}</div>;
};

export default StatusChip;
